import React from 'react';
import AliceCarousel from 'react-alice-carousel';

// Copied directly from
// `/node_modules/react-alice-carousel/lib/alice-carousel.css`. The
// copied file is left unedited, and all the overrides are defined in
// the component CSS file below.
import '../../../styles/react-alice-carousel.css';
import { FormattedMessage } from "../../../util/reactIntl";
import { NamedLink } from "../../../components";
import { newsData } from '../../../util/newsData';
import { shuffle } from "lodash";

import css from './SectionBrands.module.css';

const SectionBrands = ({ content }) => {

  const news = shuffle(newsData);

  const items = () => {
    const newsLogo = news.filter(item => !!item.logo);

    return newsLogo.map(n => {
      return (
        <NamedLink className={css.newsCarouselItem} name={n.pageLink}>
          <img className={css.newsCarouselImg} src={n.logo} alt={n.description} />
        </NamedLink>
      )
    }
    );
  };

  return (
    <div className={css.newsCarouselHolder}>
      <div className={css.rootTitleHolder}>
        <h2 className={css.rootTitle}>
          {content?.newsTitle ?
            content.newsTitle :
            <FormattedMessage id="SectionBrands.sectionTitle" />
          }
        </h2>
      </div>

      <AliceCarousel
        mouseTrackingEnabled
        items={items()}
        disableDotsControls={true}
        // infinite={true}
        responsive={{
          0: {
            items: 1,
          },
          550: {
            items: 2,
          },
          768: {
            items: 3,
          },
          1024: {
            items: 5,
          }
        }}
      />

      {/*<div className={css.buttonHolder}>*/}
      {/*  <NamedLink name="NewsListPage" className={css.primaryButton}>*/}
      {/*    {content?.newsButtonText ?*/}
      {/*      content.newsButtonText :*/}
      {/*      <FormattedMessage id="SectionBrands.sectionButton" />*/}
      {/*    }*/}
      {/*  </NamedLink>*/}
      {/*</div>*/}
    </div>
  );
};

export default SectionBrands;
